import React from "react";
import { Spinner } from "@ds/ds-snam/react";
import "./spinnerStyles.css";
import useRequestStatus from "hooks/useRequestStatus";
import { RequestStatus } from "shared/constants";

const Loader: React.FC<{}> = (): JSX.Element => {

    const requestStatus = useRequestStatus();

    return (
        requestStatus === RequestStatus.PENDING) ?
            <Spinner
                id="spinner"
                spinnerUIVariant="spinner"
                spinnerAriaLabel="loading" />

            : <></>
}
export default Loader;